var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumbersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.818,
    height: 19,
    viewBox: "0 0 13.818 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-dialpad",
    "data-name": "Icon metro-dialpad",
    d: "M14.621,19.4a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,14.621,19.4ZM9.439,3.856a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,9.439,3.856Zm0,5.182a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,9.439,9.038Zm0,5.182a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,9.439,14.22ZM19.8,7.311a1.727,1.727,0,1,0-1.727-1.727A1.727,1.727,0,0,0,19.8,7.311ZM14.621,14.22a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,14.621,14.22Zm5.182,0a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,19.8,14.22Zm0-5.182a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,19.8,9.038Zm-5.182,0a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,14.621,9.038Zm0-5.182a1.727,1.727,0,1,0,1.727,1.727A1.727,1.727,0,0,0,14.621,3.856Z",
    transform: "translate(-7.712 -3.856)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersIcon);
export default __webpack_public_path__ + "static/media/numbersIcon.a73ca8a1db57355cdb64b31c247b91ad.svg";
export { ForwardRef as ReactComponent };